// extracted by mini-css-extract-plugin
export default {"wrapper":"Services_wrapper__oXs7M","header":"Services_header__Z8aOi","cardsContainer":"Services_cardsContainer__n7GXb"};